import React, {useState} from "react";
import {usePage} from "@inertiajs/react";
import {Button} from "react-bootstrap";
import {mdiFaceAgent} from "@mdi/js";
import Icon from "@mdi/react";
import SupportTicketModal from "./SupportTicketModal.jsx";

/**
 * Der Support-Knopf in der Kopfleiste. Er wird über die headerControls in die
 * linke Nav der Kopfleiste eingehängt; das ms-auto schiebt ihn dort ans rechte
 * Ende - optisch direkt links neben den Benutzernamen. Anders als die
 * Cronjob-Bedienelemente ist er für ALLE angemeldeten Benutzer sichtbar.
 * Icon + Beschriftung statt nacktem Symbol: Der Knopf soll als Einladung
 * lesbar sein, nicht als Deko-Icon, das niemand deutet.
 */
export default function SupportHeaderControl() {
    const {supportButtonEnabled} = usePage().props;
    const [show, setShow] = useState(false);

    // Freischaltung über die Einstellungen (Bereich "Support"). Solange sie
    // aus ist, gibt es die Schaltfläche gar nicht erst.
    if (!supportButtonEnabled) {
        return null;
    }

    return (
        <div className="ms-auto d-flex align-items-center">
            <Button
                variant="outline-secondary"
                size="sm"
                className="d-inline-flex align-items-center gap-1 support-header-button"
                title="Problem melden oder Verbesserungsvorschlag einreichen"
                onClick={() => setShow(true)}
            >
                <Icon path={mdiFaceAgent} size={0.9} />
                <span className="d-none d-lg-inline">Support</span>
            </Button>
            <SupportTicketModal show={show} onHide={() => setShow(false)} />
        </div>
    );
}
